import { useEffect } from 'react';

const isEditable = (el) => {
  if (!el) return false;
  const tag = el.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || el.isContentEditable;
};

/**
 * useHotkey('mod+k', handler) – `mod` is ⌘ on macOS and Ctrl elsewhere.
 * Ignored while typing in form fields unless `allowInInputs` is true.
 */
export default function useHotkey(combo, handler, { allowInInputs = false, enabled = true } = {}) {
  useEffect(() => {
    if (!enabled) return undefined;
    const parts = combo.toLowerCase().split('+');
    const key = parts[parts.length - 1];
    const needMod = parts.includes('mod');
    const needShift = parts.includes('shift');
    const needAlt = parts.includes('alt');

    const onKeyDown = (e) => {
      const mod = e.metaKey || e.ctrlKey;
      if (needMod !== mod) return;
      if (needShift !== e.shiftKey) return;
      if (needAlt !== e.altKey) return;
      if (e.key.toLowerCase() !== key) return;
      if (!allowInInputs && !needMod && isEditable(document.activeElement)) return;
      e.preventDefault();
      handler(e);
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [combo, handler, allowInInputs, enabled]);
}
